import React, { useEffect, useState } from "react";
import {
  Breadcrumbs,
  Link,
  Drawer,
  Button,
  Typography,
  Paper,
  Box
} from "@material-ui/core";
import { Block, HomeOutlined } from "@material-ui/icons";
import BacktoHomeBtn from "../components/commons/BacktoHomeBtn";
import useStyles from "../styles/accessManagementStyle.js";
import { useTranslation } from "../langs/useTranslation";
import RoleManagementTable from "../components/accessManagement/RoleManagementTable";
// import PermissionManagementTable from "../components/accessManagement/PermissionManagementTable";
import CompanySelector from "../components/accessManagement/CompanySelector.js";
import localforage from "localforage";
import { useFormik } from "formik";
import SingleSelector from "@/components/SingleSelector";
import { languageOptions } from "@/langs";
import PlatformTab from "./PersonalizedManagement/PlatformTab";
import DeviceCenterTab from "./PersonalizedManagement/DeviceCenterTab";
import Platform from "./PersonalizedManagement/Platform";
import SupportCenter from "./PersonalizedManagement/SupportCenter";
import DeviceCenter from "./PersonalizedManagement/DeviceCenter";
import NubisDrive from "./PersonalizedManagement/NubisDrive";
import { getPersonalizedLanguageConfig, updatePersonalizedLanguageConfig } from "@/apis/apiCollection";
import { NavLink } from 'react-router-dom';
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { toast } from "@/helpers/toast";

// const makeInitValue = () => ({
//   platfromTab: {}
// })

const initialValues = {
  platformTab: {},
  deviceCenterTab: {},
  platform: {},
  supportCenter: {},
  deviceCenter: {},
  nubisDrive: {},
}

const langs = Object.keys(languageOptions).map(l => ({
  id: l,
  name: languageOptions[l]
}))

const PersonalizedManagement = () => {
  const classes = useStyles()
  const history = useHistory()
  const { t } = useTranslation("accessManagement")
  const [selectedCompanyId, setSelectedCompanyId] = useState()
  const [lang, setLang] = useState("en")
  const [loading, setLoading] = useState(true)

  const handleCompanySelect = companyId => {
    setSelectedCompanyId(companyId[0]);
  };

  const { values, handleChange, handleSubmit, handleReset, setValues } = useFormik({
    initialValues,
    onSubmit: values => {
      console.log(values)
    },
    onReset: values => {
      console.log("reset")
    },
    enableReinitialize: true
  });

  useEffect(() => {
    const lastCompanyId = sessionStorage.getItem("lastCompanyId");
    if (lastCompanyId) {
      setSelectedCompanyId(lastCompanyId);
      sessionStorage.removeItem("lastCompanyId");
      return;
    }
    localforage.getItem("userCompanyID").then(setSelectedCompanyId);
  }, []);

  useEffect(() => {
    if (!selectedCompanyId) return
    setLoading(true)
    getPersonalizedLanguageConfig({ companyId: selectedCompanyId, lang }).then(v => {
      const config = !v.lang ? {
        platformTab: {},
        deviceCenterTab: {},
        platform: {},
        supportCenter: {},
        deviceCenter: {},
        nubisDrive: {},
        lang
      } : {
        platformTab: JSON.parse(v.platformTab),
        deviceCenterTab: JSON.parse(v.deviceCenterTab),
        platform: JSON.parse(v.platform),
        supportCenter: JSON.parse(v.supportCenter),
        deviceCenter: JSON.parse(v.deviceCenter),
        nubisDrive: JSON.parse(v.nubisDrive) || {},
        lang
      }
      handleReset()
      setValues(config)
      setLoading(false)
    }, () => setLoading(false))
  }, [lang, selectedCompanyId])

  const drawer = (
    <div>
      <div className={classes.toolbar} />
      <BacktoHomeBtn />
      {/* <Divider /> */}
    </div>
  );

  return (
    <div className={classes.root}>
      <nav className={classes.drawer} aria-label="mailbox folders">
        <Drawer
          classes={{
            paper: classes.drawerPaper
          }}
          variant="permanent"
          open
        >
          {drawer}
        </Drawer>
      </nav>
      <main className={classes.content}>
        <Breadcrumbs aria-label="breadcrumb">
          <Link color="inherit" href="/">
            <HomeOutlined />
            {t({ defaultMessage: "首页" })}
          </Link>
          <Typography color="textPrimary">
            {t({ defaultMessage: "个性化管理" })}
          </Typography>
        </Breadcrumbs>
        <div className={classes.titleSection}>
          <Typography variant="h4">{t({ defaultMessage: "个性化管理" })}</Typography>
          <Typography variant="body1">
            {t({
              defaultMessage: "允许用户轻松自定义网站标题、图标和文本，以获得个性化的网络体验"
            })}
          </Typography>
        </div>
        <CompanySelector
          companyId={selectedCompanyId}
          onSelect={handleCompanySelect}
        />
        <Paper elevation={0}>
          <form onSubmit={handleSubmit}>
            <Box display="flex">
              <SingleSelector
                options={langs}
                name="lang"
                value={lang}
                onChange={e => setLang(e.target.value)}
                style={{ width: 272 }}
                clearable={false}
              />
              <Button
                variant="contained"
                color="primary"
                type="submit"
                style={{ marginLeft: "auto", padding: "0px 36px" }}
                onClick={handleReset}
              >
                {t({ defaultMessage: "重置" })}
              </Button>
              <Button
                variant="contained"
                color="primary"
                type="submit"
                style={{ padding: "0px 36px", marginLeft: 24 }}
                onClick={() => {
                  const params = {
                    platformTab: JSON.stringify(values.platformTab),
                    deviceCenterTab: JSON.stringify(values.deviceCenterTab),
                    platform: JSON.stringify(values.platform),
                    supportCenter: JSON.stringify(values.supportCenter),
                    deviceCenter: JSON.stringify(values.deviceCenter),
                    nubisDrive: JSON.stringify(values.nubisDrive),
                    lang: lang,
                    companyId: selectedCompanyId
                  }
                  updatePersonalizedLanguageConfig(params).then(() => {
                    toast.success(t({defaultMessage: "保存成功"}))
                  })
                }}
              >
                {t({ defaultMessage: "确定" })}
              </Button>
              <Button
                variant="outlined"
                style={{ padding: "0px 36px", marginLeft: 24 }}
                onClick={() => history.push("/")}
              >
                {t({ defaultMessage: "取消" })}
              </Button>
            </Box>
            <PlatformTab value={values.platformTab} onChange={handleChange} loading={loading} />
            <DeviceCenterTab value={values.deviceCenterTab} onChange={handleChange} loading={loading} />
            <Platform value={values.platform} onChange={handleChange} loading={loading} />
            <SupportCenter value={values.supportCenter} onChange={handleChange} loading={loading} />
            <DeviceCenter value={values.deviceCenter} onChange={handleChange} loading={loading} />
            <NubisDrive value={values.nubisDrive} onChange={handleChange} loading={loading} />
          </form>
        </Paper>
      </main>
    </div>
  );
};

export default PersonalizedManagement;
